import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './style.scss'
import moment from 'moment';
import 'moment/locale/he';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Select from "@material-ui/core/Select/Select";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import GenericAutosuggest from "../../GenericAutosuggest/GenericAutosuggest";
import Orders from "../Orders";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import _ from "lodash";
import Typography from "@material-ui/core/Typography";
import getSla from "../../Utils/Sla";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import PackageIcon from "../../../Utils/Icons/SVGs/PackageIcon";
import OrcaLogoImage from "../../../../resources/images/orca_logo.png";
import {AppContext} from "../../Utils/AppContext";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";
import InputAdornment from "@material-ui/core/InputAdornment";
import SaveChangeAddressDialog from "./SaveChangeAddressDialog/SaveChangeAddressDialog";
import axios from "axios";


moment.locale('he');

export default class AddEditOrderDialog extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            open: props.open,
            order: props.order ? {...props.order} : undefined,
            isOrderChanged: false,
            addressText: props.order && props.order.address ? props.order.address : "",
            isScheduledArrival: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.open && !nextProps.open) {
            this.setState({
                open: nextProps.open
            });
        } else if (!_.isEqual(this.props.order, nextProps.order) || this.props.open !== nextProps.open || this.props.isNew !== nextProps.isNew) {
            this.setState({
                open: nextProps.open,
                order: nextProps.order ? {...nextProps.order} : undefined,
                isOrderChanged: nextProps.isNew,
                addressText: nextProps.order && nextProps.order.address ? nextProps.order.address : "",
                isScheduledArrival: nextProps.order ? !!nextProps.order.scheduledArrivalTime : false,
                isNew: nextProps.isNew
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!_.isEqual(this.state.order, nextState.order) ||
            this.state.open !== nextState.open ||
            this.state.isSaveChangeAddressDialogOpen !== nextState.isSaveChangeAddressDialogOpen ||
            this.state.addressText !== nextState.addressText) {
            return true;
        }

        return false;
    }

    async shouldCheckForAddressChangeRecommendation() {
        if (!this.state.order.initialAddress ||
            !this.state.order.address ||
            !this.state.order.location)
            return false;

        const {data: manualChangesResult} = await axios.get('/api/v2/addressCache/', {
            params: {
                bid: this.context.bid,
                address: this.state.order.inputAddress,
                saveTypes: "MANUAL"
            }
        });

        if (manualChangesResult.found)
            return false;

        const {data: manualRecommendationNoAsk} = await axios.get('/api/v2/addressCache/manualRecommendationNoAsk', {
            params: {
                bid: this.context.bid,
                inputAddress: this.state.order.inputAddress
            }
        });

        if (manualRecommendationNoAsk.found)
            return false;

        return true;
    }

    async getAddressChangeRecommendation() {
        // Checking for this order address change from its initial address,
        // with the minimum changes of minAddressChangeRecommendationFly setting
        const {data: manualRecommendationsResult} = await axios.get('/api/v2/addressCache/manualRecommendations', {
            params: {
                bid: this.context.bid,
                initialAddress: this.state.order.initialAddress,
                address: this.state.order.address,
                minimumCount: Math.max(this.props.minAddressChangeRecommendationFly - 1, 1)
            }
        });

        // Return number of changes including this one
        if (manualRecommendationsResult.length > 0)
            return manualRecommendationsResult[0].count + 1;

        return 1;
    }

    handleClose() {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    async handleSave() {
        this.setState({
            open: false
        });

        if (this.state.order.source !== "SHIPIT_WEB" &&
            this.props.order.address !== this.state.order.address) {
            const shouldCheck = await this.shouldCheckForAddressChangeRecommendation();

            if (shouldCheck) {
                const addressChangeRecommendation = await this.getAddressChangeRecommendation()

                if (addressChangeRecommendation &&
                    addressChangeRecommendation >= this.props.minAddressChangeRecommendationFly) {
                    this.setState({
                        isSaveChangeAddressDialogOpen: true,
                        fromInputAddress: this.state.order.inputAddress,
                        toAddress: this.state.order.address,
                        numberOfAddressChanges: addressChangeRecommendation
                    });

                    return;
                }
            }
        }

        if (this.props.onSave)
            this.props.onSave(this.state.order);
    }

    async handleSendWithOrca() {
        if (this.props.onSendWithOrca)
            this.props.onSendWithOrca(this.state.order.id)
    }

    async onAddressSelected(address) {
        if (address) {
            const newOrder = {
                ...this.state.order,
                address: address.label,
                placeId: address.placeId,
                location: address.location
            };

            const sla = await getSla(newOrder.bid, address.location, this.state.order.isUrgent, this.state.isScheduledArrival, {
                sla: this.props.sla,
                isAreaSlaEnabled: this.props.isAreaSlaEnabled,
                scheduledSlaBefore: this.props.scheduledSlaBefore,
                scheduledSlaAfter: this.props.scheduledSlaAfter
            });

            if (sla && sla.sla)
                newOrder.sla = sla.sla;

            this.setState({
                addressText: newOrder && newOrder.address ? newOrder.address : ""
            });

            this.setOrderState(newOrder);
        }
    }

    handleOrderStatusChange(value) {
        const newOrder = {
            ...this.state.order,
            status: value
        };

        if (value !== "SCHEDULED_READY" && "minutesTillReady" in newOrder)
            delete newOrder["minutesTillReady"];

        this.setOrderState(newOrder);
    }

    async handleUrgentChange(checked) {
        let sla = undefined;

        if (this.state.order.location || checked) {
            const slaRes = await getSla(this.state.order.bid, this.state.order.location, checked, false, {
                sla: this.props.sla,
                urgentSla: this.props.urgentSla,
                isAreaSlaEnabled: this.props.isAreaSlaEnabled
            });

            if (slaRes.sla)
                sla = slaRes.sla;
        }

        const newOrder = {
            ...this.state.order,
            sla: sla,
            isUrgent: checked
        };
        delete newOrder.scheduledArrivalTime;

        this.setState({
            isScheduledArrival: false,
        });

        this.setOrderState(newOrder);
    }

    async handleIsScheduledArrivalChange(checked) {
        const newOrder = {
            ...this.state.order,
            isUrgent: false
        };

        const sla = await getSla(newOrder.bid, newOrder.location, false, checked, {
            sla: this.props.sla,
            isAreaSlaEnabled: this.props.isAreaSlaEnabled,
            scheduledSlaBefore: this.props.scheduledSlaBefore,
            scheduledSlaAfter: this.props.scheduledSlaAfter
        });

        if (checked) {
            newOrder.scheduledArrivalTime = moment();
            newOrder.scheduledSlaBefore = sla.scheduledSlaBefore;
            newOrder.scheduledSlaAfter = sla.scheduledSlaAfter;

            delete newOrder.sla;
        } else {
            if (!sla.sla)
                return;

            delete newOrder.scheduledArrivalTime;
            delete newOrder.scheduledSlaBefore;
            delete newOrder.scheduledSlaAfter;

            newOrder.sla = sla.sla;
        }

        this.setState({
            isScheduledArrival: checked,
        });

        this.setOrderState(newOrder);
    }

    handleScheduledArrivalTimeChange(value) {
        const newDate = moment(value, 'YYYY-MM-DDTHH:mm');

        this.setOrderState({
            ...this.state.order,
            scheduledArrivalTime: newDate.utc().format().replace('Z', '+00:00')
        });
    }

    onOrderTimeChanged(value) {
        const newDate = moment(value, 'YYYY-MM-DDTHH:mm');

        this.setOrderState({
            ...this.state.order,
            orderTime: newDate.utc().format().replace('Z', '+00:00')
        });
    }

    onOrderApartmentChanged(value) {
        this.setOrderState({
            ...this.state.order,
            apartmentNumber: value
        });
    }

    onOrderFloorChanged(value) {
        this.setOrderState({
            ...this.state.order,
            apartmentFloorNumber: value
        });
    }

    onOrderCustomerPhoneNumberChanged(value) {
        this.setOrderState({
            ...this.state.order,
            customerPhoneNumber: value
        });
    }

    onOrderCustomerNameChanged(value) {
        this.setOrderState({
            ...this.state.order,
            customerName: value
        });
    }

    onOrderCommentsDeliveryChanged(value) {
        this.setOrderState({
            ...this.state.order,
            commentsForDelivery: value
        });
    }

    onOrderCommentsOrderChanged(value) {
        this.setOrderState({
            ...this.state.order,
            commentsForOrder: value
        });
    }

    onOrderCashAmountChanged(value) {
        const valueNum = Number(value);

        if (valueNum < 0)
            return;

        const newPaymentMethods = [...this.state.order.paymentMethods];

        const foundCashMethodIndex = newPaymentMethods.findIndex(method => method.method === "Cash");

        if (foundCashMethodIndex === -1) {
            if (valueNum)
                newPaymentMethods.push({
                    method: "Cash",
                    amount: valueNum,
                    currency: "NIS"
                });
        } else {
            if (valueNum) {
                const newCashMethod = {...newPaymentMethods[foundCashMethodIndex]};
                newCashMethod.amount = valueNum;
                newPaymentMethods[foundCashMethodIndex] = newCashMethod;
            } else
                newPaymentMethods.splice(foundCashMethodIndex, 1);
        }

        this.setOrderState({
            ...this.state.order,
            paymentMethods: newPaymentMethods
        });
    }

    onOrderSlaChanged(value) {
        const slaNum = Number(value);

        if (slaNum < 0)
            return;

        this.setOrderState({
            ...this.state.order,
            sla: slaNum
        });
    }

    onAddressBlur() {
        this.setState({
            addressText: this.state.order && this.state.order.address ? this.state.order.address : ""
        });
    }

    onAddressTextChange(newAddressText) {
        this.setState({
            addressText: newAddressText.label
        });
    }

    async handleSaveSaveChangeAddressDialog() {
        this.setState({
            isSaveChangeAddressDialogOpen: false,
            isAddressDifferentThanInitialInput: false,
            addressCacheType: "MANUAL",
            inputAddressCacheTransform: this.state.order.address
        });

        await axios.post('/api/v2/addressCache/', {
            bid: this.context.bid,
            address: this.state.order.inputAddress,
            formattedAddress: this.state.order.address + ", ישראל",
            location: this.state.order.location,
            placeId: this.state.order.placeId
        });

        this.props.onSave(this.state.order);
    }

    handleCloseSaveChangeAddressDialog() {
        this.setState({
            isSaveChangeAddressDialogOpen: false
        });

        this.props.logInfo("closeChangeAddressRecommendationDialog", this.context.bid, {
            inputAddress: this.state.fromInputAddress,
            address: this.state.toAddress,
            numberOfChanges: this.state.numberOfAddressChanges
        });

        this.props.onSave(this.state.order);
    }

    async handleCloseDontAskAgainSaveChangeAddressDialog() {
        this.setState({
            isSaveChangeAddressDialogOpen: false
        });

        await axios.post('/api/v2/addressCache/manualRecommendationNoAsk', {
            bid: this.context.bid,
            inputAddress: this.state.order.inputAddress
        });

        this.props.onSave(this.state.order);
    }

    setOrderState(newOrder) {
        this.setState({
            order: newOrder,
            isOrderChanged: !_.isEqual(this.props.order, newOrder)
        });
    }

    render() {
        const cashMethod = this.state.order ? this.state.order.paymentMethods?.find(method => method.method === "Cash") : null;
        const cashAmount = cashMethod ? cashMethod.amount.toString() : "0";

        return (
            <React.Fragment>
                <Dialog
                    className={"edit-order-dialog " + (this.context.direction === "rtl" ? "dialog-rtl" : "dialog-ltr")}
                    open={this.state.open}
                    onClose={this.handleClose.bind(this)}
                    aria-labelledby="form-dialog-title"
                    PaperProps={{className: "edit-order-dialog-paper"}}>
                    <DialogTitle id="form-dialog-title">
                        <div className="edit-order-dialog-title-content">
                            <PackageIcon/>
                            &nbsp;
                            {
                                this.state.isNew ?
                                    <React.Fragment>
                                        משלוח חדש
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        עריכת משלוח
                                    </React.Fragment>
                            }
                        </div>
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        {this.state.order ?
                            <div className="order">
                                <div className="address-wrapper">
                                    <div className="address-autosuggest">
                                        <GenericAutosuggest autoFocus={this.state.isNew || this.props.isBadAddress}
                                                            label={"כתובת"}
                                                            placeholder={"הקלד כתובת"}
                                                            fetchPredictions={address => Orders.fetchPredictions(address, this.context.bid)}
                                                            value={this.state.addressText}
                                                            onChange={this.onAddressTextChange.bind(this)}
                                                            onBlur={this.onAddressBlur.bind(this)}
                                                            onSelect={this.onAddressSelected.bind(this)}/>
                                    </div>
                                    <TextField className="floor"
                                               label="קומה"
                                               type="text"
                                               value={this.state.order.apartmentFloorNumber || ""}
                                               onChange={event => this.onOrderFloorChanged(event.target.value)}
                                    />
                                    <TextField className="apartment"
                                               label="דירה"
                                               type="text"
                                               value={this.state.order.apartmentNumber || ""}
                                               onChange={event => this.onOrderApartmentChanged(event.target.value)}
                                    />
                                </div>
                                <div className="edit-order-dialog-divider"/>
                                <div className="customer-wrapper">
                                    <TextField className="customer-name"
                                               label="שם הלקוח"
                                               type="text"
                                               value={this.state.order.customerName || ""}
                                               onChange={event => this.onOrderCustomerNameChanged(event.target.value)}
                                    />
                                    <TextField className="customer-phone-number"
                                               label="מספר טלפון הלקוח"
                                               type="text"
                                               value={this.state.order.customerPhoneNumber || ""}
                                               onChange={event => this.onOrderCustomerPhoneNumberChanged(event.target.value)}
                                    />
                                </div>
                                <div className="edit-order-dialog-divider"/>
                                <div className="cash-and-sla">
                                    <TextField className="cash"
                                               label="מזומן"
                                               type="number"
                                               value={cashAmount || ""}
                                               onChange={event => this.onOrderCashAmountChanged(event.target.value)}
                                               InputProps={{
                                                   endAdornment: <InputAdornment position="end">₪</InputAdornment>,
                                               }}
                                    />
                                    <TextField className="sla"
                                               label="זמן התחייבות"
                                               type="number"
                                               value={this.state.order.sla === undefined || this.state.order.sla === null ? "" : this.state.order.sla.toString()}
                                               onChange={event => this.onOrderSlaChanged(event.target.value)}
                                               InputProps={{
                                                   startAdornment: <InputAdornment position="start">עד</InputAdornment>,
                                                   endAdornment: <InputAdornment position="end">דקות</InputAdornment>
                                               }}
                                    />
                                </div>
                                <div className="edit-order-dialog-divider"/>
                                <TextField className="courier-comments"
                                           multiline
                                           label="הערות לשליח"
                                           type="text"
                                           value={this.state.order.commentsForDelivery || ""}
                                           onChange={event => this.onOrderCommentsDeliveryChanged(event.target.value)}
                                />
                                <div className="edit-order-dialog-divider"/>
                                <TextField className="courier-comments"
                                           multiline
                                           label="הערות הזמנה"
                                           type="text"
                                           value={this.state.order.commentsForOrder || ""}
                                           onChange={event => this.onOrderCommentsOrderChanged(event.target.value)}
                                />
                                <div className="edit-order-dialog-divider"/>
                                <div>
                                    <Accordion className="more-details-accordion">
                                        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                            פרטים נוספים
                                        </AccordionSummary>
                                        <AccordionDetails className="more-details-accordion-content">
                                            <TextField
                                                id="datetime-local"
                                                label="זמן הזמנה"
                                                type="datetime-local"
                                                value={moment(new Date(this.state.order.orderTime)).format('YYYY-MM-DDTHH:mm')}
                                                onChange={event => this.onOrderTimeChanged(event.target.value)}
                                            />
                                            <div className="edit-order-dialog-divider"/>
                                            {
                                                this.state.isNew ? null :
                                                    <React.Fragment>
                                                        <FormControl>
                                                            <InputLabel>סטטוס</InputLabel>
                                                            <Select
                                                                className="status-select-input"
                                                                inputProps={{
                                                                    name: 'status',
                                                                    id: 'status',
                                                                }}
                                                                value={this.state.order.status}
                                                                onChange={event => this.handleOrderStatusChange(event.target.value)}
                                                            >
                                                                <MenuItem value={"ACCEPTED"}>התקבל</MenuItem>
                                                                {
                                                                    this.props.isAutopilot ?
                                                                        null
                                                                        :
                                                                        <MenuItem value={"READY"}>מוכן</MenuItem>
                                                                }
                                                                <MenuItem value={"DELIVERED"}>נמסר</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        <div className="edit-order-dialog-divider"/>
                                                    </React.Fragment>
                                            }
                                            <Typography className="special-order-text">הזמנה מיוחדת</Typography>
                                            <div>
                                                <FormControl>
                                                    <FormControlLabel label="הזמנה דחופה"
                                                                      control={
                                                                          <Checkbox
                                                                              checked={this.state.order.isUrgent || false}
                                                                              onChange={event => this.handleUrgentChange(event.target.checked)}
                                                                          />
                                                                      }
                                                                      labelPlacement="end"
                                                    />
                                                </FormControl>
                                                <FormControl>
                                                    <FormControlLabel label="הזמנה עתידית"
                                                                      control={
                                                                          <Checkbox
                                                                              checked={this.state.isScheduledArrival || false}
                                                                              onChange={event => this.handleIsScheduledArrivalChange(event.target.checked)}
                                                                          />
                                                                      }
                                                                      labelPlacement="end"
                                                    />
                                                </FormControl>
                                            </div>
                                            {
                                                !this.state.isScheduledArrival ?
                                                    null
                                                    :
                                                    <FormControl>
                                                        <TextField
                                                            id="datetime-local"
                                                            label="זמן עתידי של ההזמנה"
                                                            type="datetime-local"
                                                            value={moment(new Date(this.state.order.scheduledArrivalTime)).format('YYYY-MM-DDTHH:mm')}
                                                            onChange={event => this.handleScheduledArrivalTimeChange(event.target.value)}
                                                        />
                                                    </FormControl>
                                            }
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </div>
                            :
                            false
                        }
                    </DialogContent>
                    <DialogActions className="dialog-actions">
                        <IconButton className="close-button"
                                    onClick={this.handleClose.bind(this)}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                        {
                            !this.state.isNew && this.props.isOrcaSendingEnabled ?
                                <Button variant="contained" className="send-with-orca-button" color="primary"
                                        onClick={this.handleSendWithOrca.bind(this)}>
                                    <div className="send-with-orca-button-content">
                                        <div>שלח עם</div>
                                        &nbsp;
                                        <img src={OrcaLogoImage} className="orca-logo-image"
                                             alt="Orca logo image"/>
                                    </div>
                                </Button>
                                :
                                null
                        }
                        <Button variant="contained" color="primary"
                                onClick={this.handleSave.bind(this)} disabled={!this.state.isOrderChanged}>
                            שמור
                        </Button>
                    </DialogActions>
                </Dialog>
                <SaveChangeAddressDialog isOpen={this.state.isSaveChangeAddressDialogOpen || false}
                                         fromInputAddress={this.state.fromInputAddress}
                                         toAddress={this.state.toAddress}
                                         numberOfChanges={this.state.numberOfAddressChanges}
                                         onClose={this.handleCloseSaveChangeAddressDialog.bind(this)}
                                         onCloseDontAskAgain={this.handleCloseDontAskAgainSaveChangeAddressDialog.bind(this)}
                                         onSave={this.handleSaveSaveChangeAddressDialog.bind(this)}/>
            </React.Fragment>
        );
    }
}